import React from "react";
import MainComponentWrapper from "../Common/MainComponentWrapper";

const EarningDetailsPromotersList = ({ isError, isLoading, details }) => {
  const promoters = details?.promoters || [];

  return (
    <MainComponentWrapper Loading={isLoading} errorInfo={isError}>
      <div className="event-earning-detail-table-wrap">
        <table className="event-earning-detail-table">
          <thead>
            <tr>
              <th scope="col">Promoter Name</th>
              <th scope="col">Total Orders</th>
              <th scope="col">Total Commission</th>
            </tr>
          </thead>
          <tbody>
            {promoters.length > 0 ? (
              promoters.map((item, index) => (
                <tr key={item?._id || index} className="event-my-earnings-row">
                  <td>
                    {item?.firstName} {item?.lastName}
                  </td>
                  <td>{item?.totalOrders || 0}</td>
                  <td>
                    USD {parseFloat(item?.totalCommission || 0).toFixed(2)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3}>
                  <div className="event-earning-detail-not-found">
                    No promoters found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </MainComponentWrapper>
  );
};

export default EarningDetailsPromotersList;
